import { LibrarySkeleton } from '@/components/Library/LibrarySkeleton';
import { VIDEO_TILE_WIDTH } from '@/components/VideoTile';
import { DeleteTranslationGroupModal } from '@/pages/translation/components/DeleteTranslationGroupModal';
import { DeleteTranslationModal } from '@/pages/translation/components/DeleteTranslationModal';
import { TranslationGroupCard } from '@/pages/translation/components/TranslationGroupCard/TranslationGroupCard';
import { useAuth } from '@/services/auth';
import { useGetTranslationGroups } from '@/state/translations';
import { AppRoutes } from '@/utils/types';
import { ITranslationGroup } from '@d-id/types';
import { useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useVideoDisplayLimit } from '../../hooks/useVideoDisplayLimit';
import { SectionTitle } from '../Common';
import {
    WorkspaceSectionContainer,
    WorkspaceSectionHeader,
    WorkspaceSectionHeaderButton,
    WorkspaceTileList,
} from '../workspaceComponents/common';

export function MyTranslations() {
    const navigate = useNavigate();
    const ref = useRef<HTMLDivElement | null>(null);
    const { isAnonymous } = useAuth();

    const { data: groupsData, isLoading: groupsLoading } = useGetTranslationGroups(isAnonymous);

    const { data = [], isLoading } = { data: groupsData.groups, isLoading: groupsLoading };

    const limit = useVideoDisplayLimit(ref, data.length);
    const elements = data.slice(0, limit);
    const showSeeAll = data.length > elements.length;

    if (isLoading && !isAnonymous) {
        return (
            <WorkspaceSectionContainer>
                <WorkspaceSectionHeader>
                    <SectionTitle id="translated-videos-section">Translated Videos</SectionTitle>
                </WorkspaceSectionHeader>
                <LibrarySkeleton amount={3} tileHeight="190px" tileWidth={`${VIDEO_TILE_WIDTH}px`} />
            </WorkspaceSectionContainer>
        );
    }

    if (!data?.length) {
        return null;
    }

    return (
        <WorkspaceSectionContainer>
            <WorkspaceSectionHeader>
                <SectionTitle id="translated-videos-section">Translated Videos</SectionTitle>
                {showSeeAll && (
                    <WorkspaceSectionHeaderButton onClick={() => navigate(AppRoutes.Translation)}>See all</WorkspaceSectionHeaderButton>
                )}
            </WorkspaceSectionHeader>

            <WorkspaceTileList ref={ref}>
                {elements.map(item => (
                    <TranslationGroupCard key={item.id} translationGroup={item as ITranslationGroup} origin="home" />
                ))}
                <DeleteTranslationGroupModal />
                <DeleteTranslationModal />
            </WorkspaceTileList>
        </WorkspaceSectionContainer>
    );
}
